import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useRef, useEffect } from "react";
import { mergeRefs, Portal } from '../../utils';
import DomHandler from '../../select/DomHandler';
import ClassNames from "classnames";
import DoubleCalendar from "../date-calendar/DoubleCalendar";
import CalendarPickerContext from "../context/CalendarPickerContext";
import SingleCalendar from "../date-calendar/SingleCalendar";
import LeftMenu from "../left-menu/LeftMenu";
var CalendarPortal = function CalendarPortal(props) {
  var _inputRefList$;
  var calendarClassName = props.calendarClassName,
    navigationLayoutMode = props.navigationLayoutMode,
    formatMonth = props.formatMonth,
    navigationLabel = props.navigationLabel,
    firstDayOfWeek = props.firstDayOfWeek,
    onKeyDownForMenuMode = props.onKeyDownForMenuMode,
    isInDoubleCalendar = props.isInDoubleCalendar,
    popRef = props.popRef,
    dataMode = props.dataMode,
    getPopupContainer = props.getPopupContainer;

  // const { Portal } = usePortal({
  //   container: props.containerRef?.current
  // });

  var popupRef = useRef(null);
  var _React$useContext = React.useContext(CalendarPickerContext),
    openStatusStore = _React$useContext.openStatusStore,
    inputRefList = _React$useContext.inputRefList,
    showPanel = _React$useContext.showPanel,
    uuid = _React$useContext.uuid,
    isUsingKeyboard = _React$useContext.isUsingKeyboard,
    setIsUsingKeyboard = _React$useContext.setIsUsingKeyboard,
    datepickerAlwaysDown = _React$useContext.datepickerAlwaysDown,
    datePanelHorizontalAlign = _React$useContext.datePanelHorizontalAlign;
  var containerRef = (_inputRefList$ = inputRefList[2]) === null || _inputRefList$ === void 0 ? void 0 : _inputRefList$.current;
  var isOpen = openStatusStore.isOpen;
  useEffect(function () {
    if (isOpen && popupRef.current && containerRef.current) {
      var _containerRef$current;
      var containerWidth = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetWidth;
      popupRef.current.style.width = containerWidth + "px";
      alignOverlay();
    }
  }, [isOpen, popupRef]);
  var alignOverlay = function alignOverlay() {
    var _props$containerRef;
    DomHandler.alignOverlay(popupRef.current, containerRef, getPopupContainer ? typeof getPopupContainer === 'function' ? getPopupContainer() : getPopupContainer : (_props$containerRef = props.containerRef) === null || _props$containerRef === void 0 ? void 0 : _props$containerRef.current, 8, datepickerAlwaysDown, false, datePanelHorizontalAlign);
  };
  useEffect(function () {
    alignOverlay();
    window.addEventListener('scroll', alignOverlay);
    window.addEventListener('resize', alignOverlay);
    return function () {
      window.removeEventListener('scroll', alignOverlay);
      window.removeEventListener('resize', alignOverlay);
    };
  }, [isOpen]);
  var handleClick = function handleClick() {
    setIsUsingKeyboard(false);
  };
  var cClassName = ClassNames(calendarClassName);
  if (isInDoubleCalendar) {
    var _props$containerRef2;
    var dcn = ClassNames({
      open: isOpen,
      closed: !isOpen
    });
    var ccc = ClassNames("a-date-range-picker-double-calendar", isOpen ? "open" : "closed", {
      "a-double-calendar-has-left-panel": showPanel,
      "a-has-no-outline": !isUsingKeyboard
    });
    return /*#__PURE__*/React.createElement(Portal, {
      element: /*#__PURE__*/React.createElement("div", {
        "data-mode": dataMode,
        className: ccc,
        ref: mergeRefs(popRef, popupRef),
        id: "ap-datepicker-" + uuid,
        onClick: handleClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "a-date-range-picker-double-calendar-inner"
      }, showPanel ? /*#__PURE__*/React.createElement(LeftMenu, props) : "", /*#__PURE__*/React.createElement(DoubleCalendar, _extends({}, props, {
        className: dcn
      })))),
      container: getPopupContainer ? typeof getPopupContainer === 'function' ? getPopupContainer() : getPopupContainer : (_props$containerRef2 = props.containerRef) === null || _props$containerRef2 === void 0 ? void 0 : _props$containerRef2.current
    });
  } else {
    var _props$containerRef3;
    var _ccc = ClassNames("a-date-range-picker-calendar", isOpen ? "open" : "closed", {
      "a-date-range-picker-calendar-has-left-panel": showPanel,
      "a-has-no-outline": !isUsingKeyboard
    });
    return /*#__PURE__*/React.createElement(Portal, {
      element: /*#__PURE__*/React.createElement("div", {
        "data-mode": dataMode,
        className: _ccc,
        ref: mergeRefs(popRef, popupRef)
      }, showPanel ? /*#__PURE__*/React.createElement(LeftMenu, props) : "", /*#__PURE__*/React.createElement(SingleCalendar, _extends({}, props, {
        onKeyDownForMenuMode: onKeyDownForMenuMode,
        className: cClassName,
        navigationLayoutMode: navigationLayoutMode,
        formatMonth: formatMonth,
        navigationLabel: navigationLabel,
        firstDayOfWeek: firstDayOfWeek
      }))),
      container: getPopupContainer ? typeof getPopupContainer === 'function' ? getPopupContainer() : getPopupContainer : (_props$containerRef3 = props.containerRef) === null || _props$containerRef3 === void 0 ? void 0 : _props$containerRef3.current
    });
  }
};
export default CalendarPortal;